/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'HÃ´m nay',
  now: 'BÃ¢y giá»',
  backToToday: 'Trá» vá» hÃ´m nay',
  ok: 'Ok',
  clear: 'XÃ³a',
  month: 'ThÃ¡ng',
  year: 'NÄm',
  timeSelect: 'Chá»n thá»i gian',
  dateSelect: 'Chá»n ngÃ y',
  weekSelect: 'Chá»n tuáº§n',
  monthSelect: 'Chá»n thÃ¡ng',
  yearSelect: 'Chá»n nÄm',
  decadeSelect: 'Chá»n tháº­p ká»·',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'ThÃ¡ng trÆ°á»c (PageUp)',
  nextMonth: 'ThÃ¡ng sau (PageDown)',
  previousYear: 'NÄm trÆ°á»c (Control + left)',
  nextYear: 'NÄm sau (Control + right)',
  previousDecade: 'Tháº­p ká»· trÆ°á»c',
  nextDecade: 'Tháº­p ká»· sau',
  previousCentury: 'Tháº¿ ká»· trÆ°á»c',
  nextCentury: 'Tháº¿ ká»· sau'
};
